import { useMemo, forwardRef } from 'react';
import { buildNestedTree, applyFacet } from '@Components/Shared/FacetedSearch/FacetedSearchReducer';
import FacetedSearchLinkFieldInput from '@Components/Shared/FacetedSearch/FacetedSearchLinkFieldInput';
import FacetedSearchCheckboxFieldInput from '@Components/Shared/FacetedSearch/FacetedSearchCheckboxFieldInput';
import TranslationText from '@Components/Utilities/TranslationText';

const FacetedSearchCheckboxField = forwardRef((props, ref) => {
    const hasParent = props?.Options.some(x => x?.ParentName !== null && x?.ParentName !== undefined);
    const visibleOptions = props?.ShowAllOnLoad || hasParent ? props?.Options : props?.Options?.slice(0, props?.IsShortListCount);

    const hierarchy = useMemo(
        () => buildNestedTree(visibleOptions),
        [visibleOptions]
    );

    const options = hierarchy.options;
    const nestedTree = hierarchy.nestedTree;

    const popularOptions = (!props?.ShowPopularOptions || props?.Options?.length < props?.IsShortListCount)
        ? []
        : props.Options.slice(0).sort((a, b) => b.Count - a.Count).slice(0, 10);

    const isShortList = props?.Options?.length <= props?.IsShortListCount;

    const clickCheckBox = (e, selectedOption) => {
        let isChecked = e.target.checked != null ? e.target.checked : !selectedOption.Checked;
        let result = applyFacet(selectedOption, isChecked, options, nestedTree, props.ParentNameForSearch);
        let search = [];
        let allAvailableOptions = props.IsSpecGroup ? props.Options.map(option => option.Name.replace(' ', '')) : [];
        let fieldName = props.IsSpecGroup ? 'FacetedSpecGroup' : props.FieldName;
        if (props.ParentNameForSearch) {
            let parentOptions = result.currentFilter.filter(option => option.IsGroup).map(option => option.Value);
            let parentValues = props.IsSpecGroup ? parentOptions.join('&') : parentOptions.join('|');
            search.push({
                fieldName: props.ParentNameForSearch,
                value: parentValues,
                IsSpecGroup: props.IsSpecGroup,
                AllAvailableOptions: allAvailableOptions
            });
            let childOptions = result.currentFilter.filter(option => !option.IsGroup).map(option => option.Value);
            let childValues = props.IsSpecGroup ? childOptions.join('&') : childOptions.join('|');
            search.push({
                fieldName: fieldName,
                value: childValues,
                IsSpecGroup: props.IsSpecGroup,
                AllAvailableOptions: allAvailableOptions
            });
        } else {
            let selectedValues = result.currentFilter.map(option => option.Value);
            if (props.IsSpecGroup) {
                selectedValues = selectedValues.map(value => value.replace(' ', '') + '=1');
            }
            let value = props.IsSpecGroup ? selectedValues.join('&') : selectedValues.join('|');
            search.push({
                fieldName: fieldName,
                value: value,
                IsSpecGroup: props.IsSpecGroup,
                AllAvailableOptions: allAvailableOptions
            });
        }
        props.RunSearch(search);
    };

    const renderCheckBox = (item, isTopOptions, additionalClassNames, overloadBehavior) => {
        let key = item.ReactKey + (isTopOptions ? '-top' : '') + '-facet-field-option';
        if (item.MustBeSelectedIndividually && !item.MustBeSelectedIndividuallySkipAdditionalStyling) {
            return (
                <FacetedSearchLinkFieldInput
                    {...item}
                    key={key}
                    ShowCounts={props.ShowCounts && item.ShowCount}
                    AdditionalClassName={additionalClassNames ? additionalClassNames : undefined}
                    FieldName={props.FieldName}
                    CheckboxChange={(e) => clickCheckBox(e, item)}
                    OnKeyDown={(e) => { if (e.key === 'Enter') { clickCheckBox(e, item); } }}
                    OpenShowAllModal={props.OpenShowAllModal}
                    SegmentOverhaul={overloadBehavior}
                />
            );
        } else {
            return (
                <FacetedSearchCheckboxFieldInput
                    {...item}
                    key={key}
                    ShowCounts={props.ShowCounts && item.ShowCount}
                    AdditionalClassName={additionalClassNames ? additionalClassNames : undefined}
                    FieldName={props.FieldName}
                    CheckboxChange={(e) => clickCheckBox(e, item)}
                />
            );
        }
    };

    return (
        <div>
            {popularOptions.length > 0 ?
                <div>
                    <div className='faceted-option-checkbox-container faceted-header'>
                        <TranslationText tKey='sandhills.popular' />
                    </div>
                    {popularOptions.map((item, index) => renderCheckBox(item, true, (!isShortList && !props.ShowAllOnLoad && index > 4) ? 'hide' : '', true))}
                </div> :
                <>
                    {props.SegmentOverhaul && props.SegmentOptions ? props.SegmentOptions.map((item, index) => renderCheckBox(item, false, (!isShortList && !props.ShowAllOnLoad && index > 4) ? 'hide' : '', true)) :
                        options.map((item, index) => renderCheckBox(item, false, (!isShortList && !props.ShowAllOnLoad && index > 4) ? 'hide' : ''))

                    }</>
            }
            {
                ((!isShortList && !props.ShowAllOnLoad) || (props.SegmentOverhaul && !props.HideShowAll) || props.FilterOptionsBySelections) &&
                <div className='faceted-btn-container'>
                    <button ref={ref} className='ts-button faceted-show-all-btn' onClick={props.OpenShowAllModal}>
                        <i className='fas fa-plus' /> <TranslationText tKey='Sandhills.TradePubWebSite.MVC.ShowAll' />
                    </button>
                </div>
            }
        </div >
    );
});

export default FacetedSearchCheckboxField;